module.exports = __webpack_public_path__ + "r-1.png?d76a652b1e5ffd28bf4dc174e34a4226";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/r-1.png
// module id = 60
// module chunks = 0